import React from "react";
import HistoricalGamesDisclosure from "./HistoricalGamesDisclosure";
import { formatNbaDetailNumber, formatNbaResearchDate, nbaH2hRows } from "./nbaDetailsPresentation";

export const canRenderNbaAdminResearch = (isAdmin) => isAdmin === true;

export function nbaResearchRows(row, getRows, range) {
  return range === "H2H"
    ? nbaH2hRows(row, getRows, 10)
    : getRows(row, { max: range === "L20" ? 20 : 10, range });
}

const controlStyle = (active) => ({
  border: `1px solid ${active ? "#2563EB" : "#CBD5E1"}`,
  borderRadius: 999,
  padding: "6px 10px",
  background: active ? "#2563EB" : "transparent",
  color: active ? "#FFFFFF" : "inherit",
  fontSize: 11,
  fontWeight: 900,
  cursor: "pointer",
});

export default function NBAAdminResearchWorkbench({ row, getRows, getValue, isNarrow = false, renderGraph = null }) {
  const [range, setRange] = React.useState("L10");
  const [metric, setMetric] = React.useState("STAT_MINUTES");
  const [lineResult, setLineResult] = React.useState(false);
  const rows = nbaResearchRows(row, getRows, range);
  const prop = row?.["Prop Type"] || row?.PropType || "";
  const line = Number(row?.["Prop Value"]);
  return <section data-testid="nba-admin-research-workbench" style={{ marginTop: 14 }}>
    <div data-testid="nba-admin-historical-research-graph" style={{ border: "1px solid #E2E8F0", borderRadius: 14, padding: 14, background: "#FFFFFF" }}>
      <div style={{ display: "flex", justifyContent: "space-between", gap: 10, flexWrap: "wrap", marginBottom: 10 }}>
        <strong>Admin Historical Research Graph</strong><span style={{ color: "#64748B", fontSize: 12 }}>Oldest to newest</span>
      </div>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(210px, 1fr))", gap: 10, marginBottom: 12 }}>
        <div><div style={{ color: "#64748B", fontSize: 10, fontWeight: 900, marginBottom: 5 }}>HISTORY</div><div style={{ display: "flex", gap: 5, flexWrap: "wrap" }}>
          {["L10", "L20", "H2H"].map((value) => <button key={value} style={controlStyle(range === value)} type="button" aria-pressed={range === value} onClick={() => setRange(value)}>{value}</button>)}
        </div></div>
        <div><div style={{ color: "#64748B", fontSize: 10, fontWeight: 900, marginBottom: 5 }}>VIEW</div><div style={{ display: "flex", gap: 5, flexWrap: "wrap" }}>
          {[["STAT", "STAT"], ["MINUTES", "MINUTES"], ["STAT_MINUTES", "STAT + MINUTES"]].map(([value, label]) => <button key={value} style={controlStyle(metric === value)} type="button" aria-pressed={metric === value} onClick={() => setMetric(value)}>{label}</button>)}
          <button style={controlStyle(lineResult)} type="button" aria-pressed={lineResult} onClick={() => setLineResult((value) => !value)}>VS LINE</button>
        </div></div>
      </div>
      {rows.length && renderGraph ? renderGraph({ rows, range, metric, lineResult, line }) : (
        <div>{range === "H2H" ? "No H2H history available for the upcoming opponent." : "Historical evidence unavailable for this range."}</div>
      )}
    </div>
    <HistoricalGamesDisclosure defaultOpen={!isNarrow} resetKey={`${row?.Player || ""}|${prop}|${row?.["Prop Value"] ?? ""}|admin`}>
      <div style={{ display: "flex", justifyContent: "space-between", gap: 10, flexWrap: "wrap", marginBottom: 10 }}>
        <strong>NBA Research Workbench</strong><span style={{ color: "#64748B", fontSize: 12 }}>Admin only</span>
      </div>
      {rows.length ? <div style={{ overflowX: "auto" }}><table style={{ width: "100%", borderCollapse: "collapse", fontSize: 12 }}>
        <thead><tr>{["Date", "Matchup", ...(metric !== "MINUTES" ? ["Stat"] : []), ...(metric !== "STAT" ? ["Minutes"] : []), ...(lineResult ? ["Line Result"] : [])].map((label) => <th key={label} style={{ padding: "7px 8px", textAlign: "left", borderBottom: "1px solid #CBD5E1", whiteSpace: "nowrap" }}>{label}</th>)}</tr></thead>
        <tbody>{rows.map((game, index) => {
          const stat = getValue(game, prop, "NBA");
          const minutes = game?.Minutes ?? game?.MIN;
          const result = Number.isFinite(stat) && Number.isFinite(line) ? (stat > line ? "ABOVE LINE" : stat < line ? "BELOW LINE" : "PUSH") : "—";
          return <tr key={game?.GAME_ID || game?.GameID || index}>
            <td style={{ padding: "7px 8px", borderBottom: "1px solid #F1F5F9", whiteSpace: "nowrap" }}>{formatNbaResearchDate(game?.Date || game?.GameDate)}</td>
            <td style={{ padding: "7px 8px", borderBottom: "1px solid #F1F5F9" }}>{game?.Matchup || game?.Opponent || "—"}</td>
            {metric !== "MINUTES" && <td style={{ padding: "7px 8px", borderBottom: "1px solid #F1F5F9", fontWeight: 900 }}>{formatNbaDetailNumber(stat)}</td>}
            {metric !== "STAT" && <td style={{ padding: "7px 8px", borderBottom: "1px solid #F1F5F9" }}>{formatNbaDetailNumber(minutes)}</td>}
            {lineResult && <td style={{ padding: "7px 8px", borderBottom: "1px solid #F1F5F9", whiteSpace: "nowrap" }}>{result}</td>}
          </tr>;
        })}</tbody>
      </table></div> : <div>{range === "H2H" ? "No H2H history available for the upcoming opponent." : "Historical evidence unavailable for this range."}</div>}
    </HistoricalGamesDisclosure>
  </section>;
}
